import React, { Component } from 'react';
import { connect } from 'react-redux';
import MuiThemeProvider from 'material-ui/styles/MuiThemeProvider';
import getMuiTheme from 'material-ui/styles/getMuiTheme';
import { IntlProvider } from 'react-intl';
import { Route, Switch } from 'react-router-dom';
import CircularProgress from 'material-ui/CircularProgress';
import { ToastContainer, toast } from 'react-toastify';
import IdleTimer from 'react-idle-timer';
import InfoBar from 'routes/app/components/Agent/InfoBar/';

import MainApp from 'routes/app/';
import Login from 'routes/login/';
import ForgotPassword from 'routes/forgot-password/';
import RecoverPassword from 'routes/recover-password/';
import PrivacyPolice from 'routes/privacy-police/';
import Page404 from 'routes/404/';
import AppLocale from 'lngProvider/';
import { toggleAlertError, toggleApiError, logoutUser, openPhoneCallModal, hangUpCall } from 'stores/actions';
import APPCONFIG from 'constants/Config';
import { CopyToClipboard } from 'react-copy-to-clipboard';

import 'react-select/dist/react-select.css';
import 'font-awesome/css/font-awesome.min.css';
import 'styles/bootstrap.scss';
import 'styles/layout.scss';
import 'styles/theme.scss';
import 'styles/ui.scss';
import 'styles/app.scss';
import 'react-table/react-table.css';
import 'react-toastify/dist/ReactToastify.min.css';
import 'react-datetime/css/react-datetime.css';

import lightTheme from './themes/lightTheme';
import websocket from "stores/reducers/common/websocket";
import WebsocketComp from "components/Websocket";

class App extends Component {
  constructor() {
    super();
  }

  componentWillReceiveProps( nextProps ) {
    if( nextProps.errorMessage && this.props.errorMessage !== nextProps.errorMessage ) {
      toast(
        <div>
          {nextProps.errorMessage}
          {nextProps.msgToCopy ?
            <CopyToClipboard text={nextProps.msgToCopy}>
              <button className="btn btn-warning btn-sm mx-1"><i className="fa fa-copy"/></button>
            </CopyToClipboard> : null
          }
        </div>, {
          onClose: ( props ) => this.props.toggleAlertError( '' ),
          autoClose: nextProps.msgToCopy ? false : 5000,
          closeOnClick: !nextProps.msgToCopy
        } )
    }
    
    //if( nextProps.apiErrorMessage && this.props.apiErrorMessage !== nextProps.apiErrorMessage ) {
    //  console.log('nextProps.apiErrorMessage :>> ', nextProps.apiErrorMessage);
    //}
  }

  componentDidMount() {
    /*setTimeout( () => {
      this.callEvent( '12345' );
    }, 2000 );
    setTimeout( () => {
      this.props.hangUpCall()
    }, 6000 );*/
    this.PresenceLibraryJS = new PresenceWebAgentIntegration( this.EventMessage.bind( this ) );
  }

  EventMessage( evt ) {
    console.log( 'EventMessage. ', evt );
    if( evt.Event === APPCONFIG.presenceInboundCallEvent ) {
      this.callEvent( evt.Phone );
    }
    if( evt.Event === APPCONFIG.presenceHangUpCallEvent ) {
      this.PresenceLibraryJS.SetAllowEndContact(true);
      this.props.hangUpCall();
    }
    if( evt.Event === 'EndContactEvent' ) {
      this.PresenceLibraryJS.SetAllowEndContact(true)
    }
  }

  callEvent( phone ) {
    if( this.props.location.pathname !== '/agent' ) {
      this.props.history.push( '/agent' );
    }
    this.props.openPhoneCallModal( phone )
  }

  render() {
    const { isLoading, user, locale, websocket, apiErrorMessage } = this.props;
    const currentAppLocale = AppLocale[locale.locale];
    return (
      <IdleTimer
        idleAction={() => {if( user.access_token ) this.props.logoutUser()}}
        timeout={APPCONFIG.idleTimeout}
      >
        <MuiThemeProvider muiTheme={getMuiTheme( lightTheme )}>
          <IntlProvider
            locale={currentAppLocale.locale}
            messages={currentAppLocale.messages}
          >
            <div id="app-inner">
              <div className="full-height fixed-header">

                {isLoading ?
                  <div className="app-loading">
                    <CircularProgress size={60} thickness={7}/>
                  </div> : null
                }

                <ToastContainer
                  position={toast.POSITION.TOP_RIGHT}
                  toastClassName="dark-toast"
                  progressClassName="transparent-progress"
                  autoClose={5000}
                  newestOnTop={false}
                  closeOnClick
                  pauseOnHover
                />

                <Switch>
                  <Route path="/privacy" component={PrivacyPolice}/>
                  <Route path="/login" component={Login}/>
                  <Route path="/forgot-password" component={ForgotPassword}/>
                  <Route path="/recover-password/:token" component={RecoverPassword}/>
                  <Route path="/" component={user.access_token ? MainApp : Login}/>
                  <Route component={Page404}/>
                </Switch>
              </div>
              {apiErrorMessage &&
                <InfoBar message={apiErrorMessage} closeInfoBar={()=>this.props.toggleApiError('')} />
              }
              

              <WebsocketComp />
            </div>
          </IntlProvider>
        </MuiThemeProvider>
      </IdleTimer>
    );
  }
}

const mapStateToProps = ( state, ownProps ) => ( {
  isLoading: state.settings.isLoading,
  errorMessage: state.settings.errorMessage,
  msgToCopy: state.settings.msgToCopy,
  user: state.user,
  locale: state.settings.locale,
  apiErrorMessage: state.settings.apiErrorMessage,
} );

const mapDispatchToProps = dispatch => ( {
  logoutUser: () => {
    dispatch( logoutUser() );
  },
  toggleAlertError: ( message ) => {
    dispatch( toggleAlertError( message ) );
  },
  toggleApiError: ( apiErrorMessage ) => {
    dispatch( toggleApiError( apiErrorMessage ) );
  },
  openPhoneCallModal: ( phone ) => {
    dispatch( openPhoneCallModal( phone ) );
  },
  hangUpCall: () => {
    dispatch( hangUpCall() );
  },
} );

module.exports = connect(
  mapStateToProps,
  mapDispatchToProps
)( App );



// WEBPACK FOOTER //
// ./containers/App.js